import { selectBranch, selectedBranchShoppingCart } from "./../shopping-cart/shopping-cart.slice";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app.store";
import { setLoading } from "states/global-value/global-value.slice";
import { getBranchesAPI } from "./branch.api";
import { BranchState, IBranchModel } from "./branch.models";
import { setCookie } from "shared/plugins/list-helper";
const CURRENT_BRANCH_ID = "CurrentBranchId";
export const setBranchCookie = (value: string ) =>{
  if(value === ""){
    setCookie(CURRENT_BRANCH_ID,value,-1);
  }else{
    setCookie(CURRENT_BRANCH_ID,value,1);
  }
  
}

export const fetchBranches = createAsyncThunk(
  "branches/fetchBranches",
  async (_, thunkApi) => {
    thunkApi.dispatch(setLoading(true));
    let branches = [] as IBranchModel[];
    try {
      const res = await getBranchesAPI();
      branches =  res.data.filter(m=> m.isActive);
      const state = thunkApi.getState() as RootState;
      if (branches.length === 1 && (!state.shoppingCart.shoppingCart.branch || branches.filter(m=> m.id === state.shoppingCart.shoppingCart.branch.id).length === 0)) {
        thunkApi.dispatch(selectedBranchShoppingCart(branches[0]));
      }
      else if(branches.filter(m=> m.id === state.shoppingCart.shoppingCart.branch.id).length > 0){
        thunkApi.dispatch(selectBranch(branches.filter(m=> m.id === state.shoppingCart.shoppingCart.branch.id)[0]));
      }
      return branches;
    } catch (error) {
       console.log(error);
    }
    thunkApi.dispatch(setLoading(false));
    return branches;
  }
);

export const branchSlice = createSlice({
  name: "branch",
  initialState: {
    branches: [] as IBranchModel[],
  } as BranchState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBranches.fulfilled, (state, action) => {
      state.branches = action.payload;
    });
  },
});

export const selectBranches = (state: RootState) => state.branch.branches;
